import { Component, OnInit } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { filter, map, mergeMap } from 'rxjs/operators';
import { MatIconRegistry } from '@angular/material/icon';

import {  Event as RouterEvent,
  NavigationStart,
  NavigationCancel,
  NavigationError} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})

export class AppComponent implements OnInit {

  isLoading=true; 

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {


    this.isLoading=true;     
    this.router.events.subscribe((e : RouterEvent) => {
      this.navigationInterceptor(e);
    })


    iconRegistry.addSvgIcon(
      "menu",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/round-menu-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "date_range",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/round-date_range-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "schedule",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/round-schedule-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "dashboard",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/round-dashboard-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "account",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/twotone-account_circle-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "lock",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/twotone-lock-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "logout",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/logout.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "external-link",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/external-link.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "account-round",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/outline-account_circle-24px.svg"
      )
    );
    iconRegistry.addSvgIcon(
      "lock-outline",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/svgs/outline-account_circle-24px.svg"
      )
    );
  }

  ngOnInit() {    
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    ).subscribe((event) => this.titleService.setTitle(event['title']));

  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.isLoading = true;      
    }
    if (event instanceof NavigationEnd) {
      this.isLoading  = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.isLoading  = false
    }
    if (event instanceof NavigationError) {
      this.isLoading  = false
    }
  }

}
